/* jt-pl-chrome */
(function () {
  function isPl() {
    var loc = String((window.Shopify && Shopify.locale) || document.documentElement.lang || '').toLowerCase();
    var path = (window.location && window.location.pathname) || '';
    return loc.indexOf('pl') === 0 || /^\/pl(\/|$)/.test(path);
  }
  if (!isPl()) return;
  var SEARCH_PL = 'Szukaj produktów …';
  var SEARCH_RE = /Zoeken\s+naar\s+producten|Search\s+for\s+products|Search\s+products/i;
  function fixHero() {
    document.querySelectorAll('.custom-hero-banner, .hero, [class*="hero"]').forEach(function (wrap) {
      var text = (wrap.textContent || '').replace(/\s+/g, ' ');
      if (/TUNING\s*PARTS/i.test(text)) {
        var tw = document.createTreeWalker(wrap, NodeFilter.SHOW_TEXT, null);
        var n;
        while ((n = tw.nextNode())) {
          if (!n.nodeValue) continue;
          if (/TUNING\s*PARTS/i.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/TUNING\s*PARTS/gi, 'CZĘŚCI TUNINGOWE');
          else if (/^\s*TUNING\s*$/i.test(n.nodeValue)) n.nodeValue = 'CZĘŚCI TUNINGOWE';
          else if (/^\s*PARTS\s*$/i.test(n.nodeValue)) n.nodeValue = ' ';
        }
      }
      var hl = wrap.querySelector('.highlight');
      if (hl && /CZĘŚCI\s*TUNINGOWE/i.test(hl.textContent || '')) {
        var after = hl.nextSibling;
        while (after) {
          if (after.nodeType === 3 && /^\s*TUNINGOWE\s*$/i.test(after.nodeValue || '')) { after.nodeValue = ' '; break; }
          if (after.nodeType === 1 && /^\s*TUNINGOWE\s*$/i.test(after.textContent || '')) { after.textContent = ' '; break; }
          if (after.nodeType === 3 && /\S/.test(after.nodeValue || '') && !/TUNINGOWE/i.test(after.nodeValue || '')) break;
          after = after.nextSibling;
        }
      }
    });
  }
  function fixSearch() {
    document.querySelectorAll('input, [placeholder]').forEach(function (el) {
      var ph = el.getAttribute('placeholder') || '';
      var aria = el.getAttribute('aria-label') || '';
      var type = (el.getAttribute('type') || '').toLowerCase();
      var name = (el.getAttribute('name') || '').toLowerCase();
      var looks = type === 'search' || name === 'q' || SEARCH_RE.test(ph) || SEARCH_RE.test(aria);
      if (!looks) return;
      if (SEARCH_RE.test(ph) || !ph) el.setAttribute('placeholder', SEARCH_PL);
      if (SEARCH_RE.test(aria)) el.setAttribute('aria-label', SEARCH_PL);
    });
  }
  function boot() {
    fixHero(); fixSearch();
    [50,200,500,1000,2000,4000,8000].forEach(function (ms) { setTimeout(function () { fixHero(); fixSearch(); }, ms); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
/* jt-pl-chrome-bust:1785171150957 */

/* jt-bestellen-via-logo */
(function () {
  var path = (window.location && window.location.pathname) || '';
  if (!/bestellen-betalen-service/i.test(path)) return;
  var SRC = 'https://jt-products.eu/cdn/shop/files/Hulp_nodig_bij_je_bestelling_webp.webp?v=1779373439&width=800';
  var ALT = {
    de: 'Hilfe bei Ihrer Bestellung',
    fr: "Besoin d'aide pour votre commande",
    en: 'Need help with your order',
    it: 'Hai bisogno di aiuto con il tuo ordine',
    es: 'Necesitas ayuda con tu pedido',
    pl: 'Potrzebujesz pomocy przy skladaniu zamowienia?',
    pt: 'Precisa de ajuda com a sua encomenda?',
    nl: 'Hulp nodig bij je bestelling'
  };
  function code() {
    var l = String((window.Shopify && Shopify.locale) || document.documentElement.lang || 'nl').toLowerCase().split('-')[0];
    return ALT[l] ? l : 'nl';
  }
  function fix() {
    document.querySelectorAll('.image-with-text__image-container').forEach(function (box) {
      var ph = box.querySelector('svg.placeholder-svg');
      var img = box.querySelector('img');
      var src = img && img.getAttribute('src');
      if (src && /Hulp_nodig_bij_je_bestelling_webp/i.test(src)) return;
      var el = document.createElement('img');
      el.src = SRC;
      el.alt = ALT[code()] || ALT.nl;
      el.loading = 'lazy';
      el.setAttribute('width', '800');
      if (ph) ph.replaceWith(el);
      else if (img) { img.src = SRC; img.alt = ALT[code()] || ALT.nl; }
      else box.appendChild(el);
    });
  }
  function boot() {
    fix();
    [50, 200, 600, 1500, 3000, 6000].forEach(function (ms) { setTimeout(fix, ms); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
/* jt-bestellen-via-logo-bust:1785236808070 */

